import React from "react";
import { Link } from "react-router-dom";
import ServiceTile from "../shared/ServiceTile";
import { SkeletonImage } from "../shared/Skeleton";
import { t } from "../../lib/i18n";

export default function ServiceTilesSection({ services, coversById, loading }) {
  return (
    <section
      data-testid="home-services-section"
      className="mx-auto max-w-6xl px-5 pt-20 pb-16 sm:px-6 sm:pt-28 sm:pb-20"
    >
      <div className="mb-10 flex flex-col gap-3 sm:mb-14 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-display text-3xl text-[#1A1A1A] sm:text-4xl lg:text-5xl">
            {t("home.services.title")}
          </h2>
          <p className="mt-3 max-w-xl text-base text-[#1A1A1A]/60">
            {t("home.services.subtitle")}
          </p>
        </div>
        <Link
          to="/services"
          data-testid="home-services-view-all"
          className="text-xs uppercase tracking-[0.28em] text-[#1A1A1A]/70 transition hover:text-[#C8A24B]"
        >
          {t("home.viewAll.services")} →
        </Link>
      </div>

      <ul
        data-testid="home-services-list"
        className="grid grid-cols-1 gap-6 md:grid-cols-3"
      >
        {loading
          ? Array.from({ length: 3 }).map((_, i) => (
              <li key={i}>
                <SkeletonImage className="aspect-[4/5] w-full" />
              </li>
            ))
          : services.map((svc) => (
              <li key={svc.id}>
                <ServiceTile service={svc} coverImage={coversById[svc.id]} />
              </li>
            ))}
      </ul>
    </section>
  );
}
